module.exports = __webpack_public_path__ + "media/images/icon_crown05-e363f53733bf9621bd825cd1d21489ab.png";